<script setup lang="ts">
defineProps({
  content: {
    type: String,
    default: 'Load more'
  },
  invert: {
    type: Boolean,
    default: false
  }
})

const sectionRef = ref<HTMLElement | null>(null)
const isVisible = ref(false)

const { stop } = useIntersectionObserver(
  sectionRef,
  ([entry], _observerElement) => {
    if (entry?.isIntersecting && !isVisible.value) {
      isVisible.value = true
    }
  },
  { threshold: 0.5 }
)

onUnmounted(() => {
  stop()
})
</script>

<template>
  <button
    ref="sectionRef"
    type="button"
    class="w-full pb-10 pt-8 text-center text-3xl font-light uppercase transition-colors duration-300 lg:py-20 lg:text-5xl"
    :class="
      invert
        ? 'bg-cream text-yellow hover:text-grey-light'
        : 'bg-black text-yellow hover:text-cream'
    "
  >
    <span
      class="container transition-opacity delay-500 duration-1000"
      :class="isVisible ? 'opacity-100' : 'opacity-0'"
    >
      {{ content }}
    </span>
  </button>
</template>
